<template>
  <fieldset>
    <div class="mb-3">
      <div class="input-group mb-1">
        <div class="input-group-prepend">
          <div class="input-group-text">Visning</div>
        </div>
        <select class="custom-select" required v-model="mode" @change="onUpdate">
          <option value="hidden">Dold</option>
          <option value="inline">Direkt på kundsidan</option>
          <option value="popup">Länk till popup på kundsidan</option>
        </select>
      </div>

      <p class="small">
        <code>Dold</code> används enbart för Visitkort
      </p>
    </div>

    <div class="input-group mb-1">
      <div class="input-group-prepend">
        <div class="input-group-text">Event ID</div>
      </div>
      <input type="text" class="form-control" required v-model="eventId" @input="onUpdate">
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const eventId = ref(null);
const mode = ref(null);
const serializedValue = computed(() => {
  return {
    event_id: eventId.value,
    mode: mode.value
  };
});
function onUpdate() {
  emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    eventId.value = modelValue.value.event_id;
    mode.value = modelValue.value.mode ?? 'popup';
  }
}, {
  immediate: true
});
</script>
